import { render, staticRenderFns } from "./RowsTable.vue?vue&type=template&id=adabd1c8&scoped=true&"
import script from "./RowsTable.vue?vue&type=script&lang=ts&"
export * from "./RowsTable.vue?vue&type=script&lang=ts&"
import style0 from "./RowsTable.vue?vue&type=style&index=0&id=adabd1c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adabd1c8",
  null
  
)

export default component.exports